import fetch from "cross-fetch"

export const get = path => {
  let fetchSettings = {
    method: 'GET',
    headers: {
      'X-Accept': 'application/json',
      'Content-Type': 'application/json; charset=UTF8 ',
    },
  }

  return fetch(path, fetchSettings)
  .then(handleErrors)
  .then(response => response.json())
  .catch(console.error)
}

export const post = (path, data) => {
  let fetchSettings = {
    method: 'POST',
    body: data
  }

  return fetch(path, fetchSettings)
  .then(handleErrors)
  .then(response => response.json())
  .catch(console.error)
}

export const handleErrors = (response) => {
  if (!response.ok) throw Error(response.statusText)
  return response
}
